import Backbone from 'backbone'
import _ from 'lodash'

export default Backbone.View.extend({

  initialize: function (options) {
    this.canvas = options.canvas
    this.to = options.to
    this.from = options.from
    this.active = options.active
    this.diff = options.diff
    this.prop = options.prop
    this.direction = options.direction

    this.coords = this.coords(this.from, this.to, this.prop)
  },

  render: function () {
    this.$el.addClass(this.type)
            .addClass(`align-${this.prop}`)

    // Pass the coords to set, but remove `right` and `bottom` properties
    this.set(_.omit(this.coords, 'right', 'bottom'))
    return this
  },

  /*
   * Receives the all the guides at this guide's `direction`.
   */
  adjust: function (guides) {
    return this
  },

  coords: () => {},

  set: function (values) {
    this.$el.css(values)
  },

  release: function () {
    this.remove()
  }
})
